import type { ParsedMcpServer } from '@utils/mcp-config';
import * as yup from 'yup';

const serverNamePattern = /^[a-zA-Z0-9_-]+$/;
const serverNameMessage =
  'Name must only contain letters, numbers, underscores, and hyphens (no spaces or special characters)';

export const mcpServerNameSchema = yup
  .string()
  .required('Name is required')
  .max(128, 'Name must be 128 characters or less')
  .matches(serverNamePattern, { message: serverNameMessage });

export const mcpServerDescriptionSchema = yup.string();

export const mcpServerConfigSchema = yup
  .array()
  .required('Config is required')
  .test('valid-server-config', 'Invalid server name in config', (value, context) => {
    if (!value || value.length === 0) return true;
    const servers = value as ParsedMcpServer[];
    const invalidServerNames = servers
      .filter((server) => !serverNamePattern.test(server.name))
      .map((server) => server.name);
    if (invalidServerNames.length > 0) {
      return context.createError({
        message: `Server name${invalidServerNames.length > 1 ? 's' : ''} '${invalidServerNames.join(', ')}' ${invalidServerNames.length > 1 ? 'are' : 'is'} invalid: ${serverNameMessage}`,
      });
    }
    return true;
  });
